// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"909aedda","952":"65de50e0"}[chunkId] + ".chunk.js";
};